import React from 'react'
import Tick from '../../assets/img/LKaXU.png'
import Cross from '../../assets/img/cross.png'
import PropTypes from 'prop-types'
import { EMPTY_OBJECT } from '../../constants/globalConstants'

function ThankYouCard(props) {
  const{paymentStatus, paymentResponse, systemError, havingQR,systemErrorMessage} = props
  
  return (
    <div className="container">
      <div className="row my-4 justify-content-center">
        <div className="col col-sm-8">
          <div className={paymentStatus ? 'border-success d-flex flex-row shadow align-items-center card p-4' : 'border-danger d-flex flex-row shadow align-items-center card p-4'}>
            <div>
              <img width="100px" src={paymentStatus && !systemError ? Tick : Cross} />
            </div>
            <div className="ms-4">
            {paymentStatus && !systemError ? <h3 className="text-success mb-0">Your Booking ID #{paymentResponse?.ticketech_code} Is Confirmed!</h3> : paymentStatus && systemError ? <h3 className="text-danger mb-0">Error!</h3> : <h3 className="text-danger mb-0">Payment failed!</h3>}
              {/* <h3 className="text-success mb-0">{paymentStatus ? `Your Booking ID #${paymentResponse?.ticketech_code} Is Confirmed!` : 'Paymen failed!'}</h3> */}
              <p>
                {paymentStatus && !systemError && !havingQR ? 'Something went wrong while generating tickets. Please do not book again, and save the booking Id for future refrence. Contact to our customer support regarding the same.' : paymentStatus && !systemError ? `Thank you for the purchase, You can download the ticket for the ${paymentResponse?.mapco_qrcode?.length > 1 ? 'events' : 'event'} below.` : paymentStatus && systemError ? systemErrorMessage ? systemErrorMessage : 'Something went wrong. Please check your network connection and try again in some time. If your card is already charged, then please contact our support team.' : 'Something went wrong, please check your card details. If your amount is deducted, please contact to our support team.'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

ThankYouCard.propTypes = {
	paymentStatus: PropTypes.bool,
	paymentResponse: PropTypes.object,
  systemError: PropTypes.bool,
  havingQR: PropTypes.bool,
  systemErrorMessage:PropTypes.string,
}

ThankYouCard.defaulProps = {
	paymentStatus: false,
	paymentResponse: EMPTY_OBJECT,
  systemError: false,
  havingQR: false,
  systemErrorMessage: null
}
export default ThankYouCard
